import { useEffect, useState } from "react";

import { breakpointObj } from "@eriksdigital/atomic-ui/styles";

export const BREAKPOINTS_LABELS = {
  phone: "phone",
  phoneLarge: "phoneLarge",
  tabletPortrait: "tabletPortrait",
  tabletIpadPortrait: "tabletIpadPortrait",
  tabletLandscape: "tabletLandscape",
  desktop: "desktop",
  giant: "giant",
};

export const getMediaQueryByLabel = (label: string) =>
  `min-width: ${breakpointObj[label] / 16}em`;

export const useMedia = (label: string) => {
  const query = "(" + getMediaQueryByLabel(label) + ")";
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => setMatches(media.matches);
    media.addEventListener("change", listener);

    return () => media.removeEventListener("change", listener);
  }, [matches, query]);

  return matches;
};
